import Vue from 'vue';
import '@/plugins/vuetify';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/store';
import * as db from '@/utils/database';
import VueAnalytics from 'vue-analytics';
import titleMixin from '@/utils/title';
import VueI18n from 'vue-i18n';
import messages from '@/plugins/i18n.json';

Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: 'en',
	messages
});

Vue.config.productionTip = false;

(async () => {
	Vue.prototype.$db = db;
	new Vue({
		router,
		store,
		i18n,
		render: (h) => h(App)
	}).$mount('#app');
})();

Vue.mixin(titleMixin);

// moment
const VueMoment = require('vue-moment');
const moment = require('moment-timezone');
moment.locale('ja');

Vue.use(VueMoment, {
	moment
});

Vue.use(VueAnalytics, {
	id: 'UA-90092457-1',
	router
});
